import type { Order, PublicOnlineOrderingConfig } from '../types';

/** Online ordering is opt-in: only available when explicitly enabled in Settings. */
export function isPublicOnlineOrderingEnabled(
  config: PublicOnlineOrderingConfig | null | undefined
): boolean {
  return config?.onlineOrderingEnabled === true;
}

/**
 * Unpaid web pickup orders: payment happens on the customer device (Windcave HPP).
 * Hide these from POS Pending / Active until `paymentStatus === 'paid'` so staff are not
 * prompted for orders the customer has not finished paying for.
 */
export function isUnpaidOnlineWebOrder(order: Order): boolean {
  return order.orderType === 'online' && order.paymentStatus === 'unpaid';
}

/**
 * True when the order is waiting for the customer to finish Windcave (used for Firestore flagging).
 * For POS lists, prefer {@link isUnpaidOnlineWebOrder} so drafts still hide if the flag is missing.
 */
export function isOnlineCheckoutPending(order: Order): boolean {
  return isUnpaidOnlineWebOrder(order) && Boolean(order.onlineAwaitingHpp);
}
